import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type clientTransactionState = {
  clientTransfer: number | null;
}

const initialState: clientTransactionState = {
    clientTransfer: null,
};

const clientTransferSlice = createSlice({
  name: 'clientTransfer',
  initialState,
  reducers: {
    setClientTransfer: (state, action: PayloadAction<number | null>) => {
      state.clientTransfer = action.payload;
    },
  },
});

export const { setClientTransfer } = clientTransferSlice.actions;
export default clientTransferSlice;
